/**
 * カレントページのリンクやその親に .is-current を付与（Vanilla JS） ver1.0.0
 * ES6
 *
 * □機能
 * ・カレントページとその親の a または [data-get-current-set] 全てに .is-current を付与する
 *
 * □使い方
 * .js-getcurrent-ignore で除外対象
 *
 */
export default (APP) => {
  const pathRoot = APP.path.root
  const pathRootArray = pathRoot.split('/').filter(Boolean)

  const pathName = window.location.pathname
  const data = pathName.split('/').filter(Boolean)
  const dataLength = data.length

  const pathArray = []
  for (let i = 0; i < dataLength; i++) {
    if (pathRootArray[i] !== data[i]) {
      pathArray.push(data[i])
    }
  }

  pathArray[0] = (pathArray[0]) ? pathArray[0] + '/' : ''

  const pathAbsolute = window.location.protocol + '//' + window.location.host
  const parent = pathRoot + pathArray[0]

  const current = {
    relative: pathName,
    absolute: pathAbsolute + pathName
  }

  const parents = {
    relative: parent,
    absolute: pathAbsolute + parent
  }

  const targetParents = document.querySelectorAll(
    'a:not(.js-getcurrent-ignore)[href="' + parents.relative + '"],' +
    'a:not(.js-getcurrent-ignore)[href="' + parents.absolute + '"]'
  )

  const targetCurrents = document.querySelectorAll(
    'a:not(.js-getcurrent-ignore)[href="' + current.relative + '"],' +
    'a:not(.js-getcurrent-ignore)[href="' + current.absolute + '"],' +
    '[data-get-current-set="' + current.relative + '"],' +
    '[data-get-current-set="' + current.absolute + '"]'
  )

  if (targetParents.length) {
    APP.ex.addClass(targetParents, ['is-current-parent', 'is-current'])
  }

  if (targetCurrents.length) {
    APP.ex.addClass(targetCurrents, 'is-current')
  }
}
